/* eslint-disable no-bitwise */
import type { IAugmentedJQuery, IController, IScope } from "angular";

export default class EnumFlagShowDirectiveController implements IController {
    public static $inject = ["$scope", "$element"];

    public model: number;

    public flagValue: number;

    constructor(private $scope: IScope, private $element: IAugmentedJQuery) {}

    public $onInit() {
        const hiddenClass = "ng-hide";

        let isVisible = true;

        if ((this.model & this.flagValue) !== this.flagValue) {
            this.$element.addClass(hiddenClass);
            isVisible = false;
        }

        this.$scope.$watch("$ctrl.model", (newValue: number, oldValue: number) => {
            if ((newValue & this.flagValue) === (oldValue & this.flagValue)) {
                return;
            }

            const shouldBeVisible = (this.model & this.flagValue) === this.flagValue;
            if (shouldBeVisible !== isVisible) {
                if (shouldBeVisible) {
                    this.$element.removeClass(hiddenClass);
                } else {
                    this.$element.addClass(hiddenClass);
                }
                isVisible = shouldBeVisible;
            }
        });
    }
}
/* eslint-enable */
